import { library } from '@fortawesome/fontawesome-svg-core'
// brands
import { faFacebookF as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faLinkedinIn as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faWhatsapp as fabWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp'
import { faXing as fabXing } from '@fortawesome/free-brands-svg-icons/faXing'
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import {
  faAmbulance as falAmbulance,
  faArrowsCross as falArrowsCross,
  faFileLines as falFileLines,
  faHeartbeat as falHeartbeat,
  faLocationPlus as falLocationPlus,
  faMessagePen as falMessagePen,
  faMobile as falMobile,
} from '@fortawesome/pro-light-svg-icons'
// light
import { faAddressCard as falAddressCard } from '@fortawesome/pro-light-svg-icons/faAddressCard'
import { faArrowDownToLine as falArrowDownToLine } from '@fortawesome/pro-light-svg-icons/faArrowDownToLine'
import { faArrowRight as falArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faArrowRightToBracket as falArrowRightToBracket } from '@fortawesome/pro-light-svg-icons/faArrowRightToBracket'
import { faArrowUpRightFromSquare as falArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare'
import { faBaby as falBaby } from '@fortawesome/pro-light-svg-icons/faBaby'
import { faBallotCheck as falBallotCheck } from '@fortawesome/pro-light-svg-icons/faBallotCheck'
import { faBan as falBan } from '@fortawesome/pro-light-svg-icons/faBan'
import { faBed as falBed } from '@fortawesome/pro-light-svg-icons/faBed'
import { faBellConcierge as falBellConcierge } from '@fortawesome/pro-light-svg-icons/faBellConcierge'
import { faBook as falBook } from '@fortawesome/pro-light-svg-icons/faBook'
import { faBookOpen as falBookOpen } from '@fortawesome/pro-light-svg-icons/faBookOpen'
import { faCalculatorSimple as falCalculatorSimple } from '@fortawesome/pro-light-svg-icons/faCalculatorSimple'
import { faCalendar as falCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar'
import { faCheck as falCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faCircle as falCircle } from '@fortawesome/pro-light-svg-icons/faCircle'
import { faCircleArrowDown as falCircleArrowDown } from '@fortawesome/pro-light-svg-icons/faCircleArrowDown'
import { faCircleCheck as falCircleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck'
import { faCircleExclamation as falCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation'
import { faCircleH as falCircleH } from '@fortawesome/pro-light-svg-icons/faCircleH'
import { faCircleInfo as falCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faCirclePause as falCirclePause } from '@fortawesome/pro-light-svg-icons/faCirclePause'
import { faCirclePlay as falCirclePlay } from '@fortawesome/pro-light-svg-icons/faCirclePlay'
import { faCircleQuestion as falCircleQuestion } from '@fortawesome/pro-light-svg-icons/faCircleQuestion'
import { faCircleXmark as falCircleXmark } from '@fortawesome/pro-light-svg-icons/faCircleXmark'
import { faClipboardCheck as falClipboardCheck } from '@fortawesome/pro-light-svg-icons/faClipboardCheck'
import { faClipboardList as falClipboardList } from '@fortawesome/pro-light-svg-icons/faClipboardList'
import { faClock as falClock } from '@fortawesome/pro-light-svg-icons/faClock'
import { faComments as falComments } from '@fortawesome/pro-light-svg-icons/faComments'
import { faEnvelope as falEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faFaceAngry as falFaceAngry } from '@fortawesome/pro-light-svg-icons/faFaceAngry'
import { faFaceGrinStars as falFaceGrinStars } from '@fortawesome/pro-light-svg-icons/faFaceGrinStars'
import { faFaceMeh as falFaceMeh } from '@fortawesome/pro-light-svg-icons/faFaceMeh'
import { faFaceSmile as falFaceSmile } from '@fortawesome/pro-light-svg-icons/faFaceSmile'
import { faFamily as falFamily } from '@fortawesome/pro-light-svg-icons/faFamily'
import { faFile as falFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faFileCheck as falFileCheck } from '@fortawesome/pro-light-svg-icons/faFileCheck'
import { faFilter as falFilter } from '@fortawesome/pro-light-svg-icons/faFilter'
import { faFlowerDaffodil as falFlowerDaffodil } from '@fortawesome/pro-light-svg-icons/faFlowerDaffodil'
import { faGear as falGear } from '@fortawesome/pro-light-svg-icons/faGear'
import { faGlobe as falGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faGrid2 as falGrid2 } from '@fortawesome/pro-light-svg-icons/faGrid2'
import { faHandPointRight as falHandPointRight } from '@fortawesome/pro-light-svg-icons/faHandPointRight'
import { faImages as falImages } from '@fortawesome/pro-light-svg-icons/faImages'
import { faLifeRing as falLifeRing } from '@fortawesome/pro-light-svg-icons/faLifeRing'
import { faLightbulb as falLightbulb } from '@fortawesome/pro-light-svg-icons/faLightbulb'
import { faListRadio as falListRadio } from '@fortawesome/pro-light-svg-icons/faListRadio'
import { faLocationDot as falLocationDot } from '@fortawesome/pro-light-svg-icons/faLocationDot'
import { faMagnifyingGlass as falMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass'
import { faMapLocationDot as falMapLocationDot } from '@fortawesome/pro-light-svg-icons/faMapLocationDot'
import { faMessageImage as falMessageImage } from '@fortawesome/pro-light-svg-icons/faMessageImage'
import { faMessages as falMessages } from '@fortawesome/pro-light-svg-icons/faMessages'
import { faPhone as falPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faPlus as falPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faPodcast as falPodcast } from '@fortawesome/pro-light-svg-icons/faPodcast'
import { faQuestion as falQuestion } from '@fortawesome/pro-light-svg-icons/faQuestion'
import { faShareNodes as falShareNodes } from '@fortawesome/pro-light-svg-icons/faShareNodes'
import { faSpa as falSpa } from '@fortawesome/pro-light-svg-icons/faSpa'
import { faSquare as falSquare } from '@fortawesome/pro-light-svg-icons/faSquare'
import { faSquarePollVertical as falSquarePollVertical } from '@fortawesome/pro-light-svg-icons/faSquarePollVertical'
import { faStar as falStar } from '@fortawesome/pro-light-svg-icons/faStar'
import { faTrash as falTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { faUserDoctor as falUserDoctor } from '@fortawesome/pro-light-svg-icons/faUserDoctor'
import { faUserDoctorHair as falUserDoctorHair } from '@fortawesome/pro-light-svg-icons/faUserDoctorHair'
import { faUserDoctorHairLong as falUserDoctorHairLong } from '@fortawesome/pro-light-svg-icons/faUserDoctorHairLong'
import { faUserTie as falUserTie } from '@fortawesome/pro-light-svg-icons/faUserTie'
import { faVolumeHigh as falVolumeHigh } from '@fortawesome/pro-light-svg-icons/faVolumeHigh'
import { faXmark as falXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
// regular
import { faArrowRightLong as farArrowRightLong } from '@fortawesome/pro-regular-svg-icons/faArrowRightLong'
import { faChevronRight as farChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import { faExpand as farExpand } from '@fortawesome/pro-regular-svg-icons/faExpand'
import { faXmark as fasXmark } from '@fortawesome/pro-solid-svg-icons'
// solid
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faFaceAngry as fasFaceAngry } from '@fortawesome/pro-solid-svg-icons/faFaceAngry'
import { faFaceGrinStars as fasFaceGrinStars } from '@fortawesome/pro-solid-svg-icons/faFaceGrinStars'
import { faFaceMeh as fasFaceMeh } from '@fortawesome/pro-solid-svg-icons/faFaceMeh'
import { faLightbulb as fasLightbulb } from '@fortawesome/pro-solid-svg-icons/faLightbulb'
import { faSquareCheck as fasSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck'
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(falAddressCard)
library.add(falArrowDownToLine)
library.add(falArrowRight)
library.add(falArrowRightToBracket)
library.add(falArrowUpRightFromSquare)
library.add(falBaby)
library.add(falBallotCheck)
library.add(falBan)
library.add(falBed)
library.add(falBellConcierge)
library.add(falBook)
library.add(falBookOpen)
library.add(falCalculatorSimple)
library.add(falCalendar)
library.add(falCheck)
library.add(falChevronDown)
library.add(falChevronRight)
library.add(falCircle)
library.add(falCircleArrowDown)
library.add(falCircleCheck)
library.add(falCircleExclamation)
library.add(falCircleH)
library.add(falCircleInfo)
library.add(falCirclePause)
library.add(falCirclePlay)
library.add(falCircleXmark)
library.add(falCircleQuestion)
library.add(falClipboardCheck)
library.add(falClipboardList)
library.add(falClock)
library.add(falComments)
library.add(falEnvelope)
library.add(falFaceGrinStars)
library.add(falFaceMeh)
library.add(falFaceAngry)
library.add(falFaceSmile)
library.add(falFamily)
library.add(falFile)
library.add(falFileCheck)
library.add(falFilter)
library.add(falFlowerDaffodil)
library.add(falGear)
library.add(falGlobe)
library.add(falGrid2)
library.add(falHandPointRight)
library.add(falImages)
library.add(falLifeRing)
library.add(falLightbulb)
library.add(falListRadio)
library.add(falLocationDot)
library.add(falMagnifyingGlass)
library.add(falMapLocationDot)
library.add(falMessages)
library.add(falMessageImage)
library.add(falPhone)
library.add(falPlus)
library.add(falPodcast)
library.add(falQuestion)
library.add(falShareNodes)
library.add(falSpa)
library.add(falSquare)
library.add(falSquarePollVertical)
library.add(falStar)
library.add(falTrash)
library.add(falUser)
library.add(falUserDoctor)
library.add(falUserDoctorHair)
library.add(falUserDoctorHairLong)
library.add(falUserTie)
library.add(falVolumeHigh)
library.add(falXmark)
library.add(falFileLines)
library.add(falHeartbeat)
library.add(falAmbulance)
library.add(falArrowsCross)
library.add(falLocationPlus)
library.add(falMessagePen)
library.add(falMobile)

library.add(farArrowRightLong)
library.add(farChevronRight)
library.add(farExpand)

library.add(fasChevronDown)
library.add(fasCircle)
library.add(fasFaceGrinStars)
library.add(fasFaceMeh)
library.add(fasFaceAngry)
library.add(fasLightbulb)
library.add(fasSquareCheck)
library.add(fasStar)
library.add(fasXmark)

library.add(fabFacebook)
library.add(fabInstagram)
library.add(fabLinkedin)
library.add(fabTwitter)
library.add(fabWhatsapp)
library.add(fabXing)
library.add(fabYoutube)

export default FontAwesomeIcon

export const ART = {
  fal: 'light',
  far: 'regular',
  fas: 'solid',
  fab: 'brand',
}
